import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { Auth } from '../../injectable'

@Component({
    selector: 'app-logging-out',
    templateUrl: 'logging-out.html'
})
export class LoggingOutComponent {
    // Constructor
    constructor(private _auth: Auth, private _router: Router) {
        setTimeout(() => {
            this._auth.logout()
            this._router.navigateByUrl('/onboarding?success_message=You have been logged out')
        }, 1000);
    }
}
